module.exports = __webpack_public_path__ + "img/146.8c0089af.png";